import { createFileRoute } from '@tanstack/react-router'
import WastePage from 'pages/app/waste-page/WastePage'

export const Route = createFileRoute(
  '/_authenticated/app/uppdrag/$uuid/tomning/$wasteId'
)({
  component: WastePage,
})
